import { gql } from "@apollo/client";

export const INTENT_PROJECT_BASIC_FRAGMENT = gql`
  fragment IntentProjectBasic on IntentProject {
    id
    name
    description
    createdAt
    lastResourcesUpdatedAt
    createdBy
    lockedBy
    space {
      id
      name
    }
  }
`;

export const INTENT_PROJECT_FULL_FRAGMENT = gql`
  fragment IntentProjectFull on IntentProject {
    ...IntentProjectBasic
  }
  ${INTENT_PROJECT_BASIC_FRAGMENT}
`;

export const AWS_INTEGRATION_ATTACHMENT_FRAGMENT = gql`
  fragment AwsIntegrationAttachment on AwsIntegrationIntentProjectAttachment {
    id
    read
    write
    awsIntegration {
      id
      name
      labels
      spaceDetails {
        id
        name
      }
    }
    intentProject {
      id
      name
    }
  }
`;
